export default __webpack_public_path__ + "static/media/mayowa_wyd1.8a0618e8.jpg";